import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addLeavePolicy = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Leave Policy',
    body
  );
  return data;
});
export const updateLeavePolicy = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Leave Policy/${id}`,
    body
  );
  return data;
});

export const getLeavePolicy = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Leave Policy?fields=["name","docstatus","title"]&limit_page_length=10&limit_start=0&order_by=creation desc'
  );
  return data;
});
export const deleteLeavePolicy = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Leave Policy/${record}`
  );
  return data;
});
export const getLeavePolicyDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Leave Policy/${id}`
  );
  return data;
});
